import { useAuth0 } from "@auth0/auth0-react";
import MyButton from "components/MyButton";
// import Tabs from "components/Tabs";
import { SubHeader } from "layout/SubHeader";
import AuthService from "Lib/API/Auth";
import FinanceService from "Lib/API/Finance";
import { addAllContacts, addProducts } from "pages/School/Classes/classSlice";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
// import ColsedInvoices from "./InvoicesTable/ColsedInvoices";
import "./index.scss";
import InvoicesFilter from "./InvoicesTable/invoicesFilter";
import OpenedInvoices from "./InvoicesTable/OpenedInvoices";
const Invoices = () => {
  const dispatch = useDispatch();
  const { contacts, products } = useSelector((state) => state?.data);
  const { getAccessTokenSilently } = useAuth0();
  // const [activeTab, setActiveTab] = useState(0);
  const [productId, setProductId] = useState("");
  const [memberId, setMemberId] = useState("");
  const [FList, setList] = useState([]);
  const [FTotal, setTotal] = useState(0);
  const [FPage, setPage] = useState(0);
  const [loading, setLoading] = React.useState(false);
  const [selectionModel, setSelectionModel] = React.useState([]);

  const history = useHistory();
  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      await AuthService.getAccount(token)
        .then((res) => {
          if (res) {
            const result = [];
            res.contacts.map((item) => {
              result.push({
                value: item?._id,
                label: item?.first_name + " " + item?.last_name,
              });
              return item;
            });
            dispatch(addAllContacts(result));
          }
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);

        });
    }
    if (contacts?.length === 0) fetchMyAPI();
  }, []);
  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      await FinanceService.getFilteredProducts("filter?active=true", token)
        .then((res) => {
          if (res) {
            const result = [];
            res.map((item) => {
              result.push({
                value: item._id,
                label: item.prod_name,
              });
              return item;
            });
            dispatch(addProducts(result));
          }
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }
    if (products?.length === 0) fetchMyAPI();
  }, []);
  return (
    <div className="school-classes pr-12 pt-5">
      <div className="header">
        <div className="header-tittle">
          <SubHeader
            className="subheader"
            {...{
              title: "Invoices",
            }}
          />
        </div>
        <div className="new-class">
          <MyButton
            style={{ width: "190px" }}
            type={"primary"}
            content={"Create new Invoice"}
            onClick={() => history.push("/create-invoice")}
          />
        </div>
      </div>

      <div>
        <div className="">
          <hr />
          <InvoicesFilter
            productId={productId}
            memberId={memberId}
            setMemberId={setMemberId}
            setProductId={setProductId}
            setTotal={setTotal}
            FPage={FPage}
            setList={setList}
            setLoading={setLoading}
            list={FList}
            selectionModel={selectionModel}
            status="open"
          />
          <OpenedInvoices
            productId={productId}
            memberId={memberId}
            FList={FList}
            FTotal={FTotal}
            setPage={setPage}
            loading={loading}
            setSelectionModel={setSelectionModel}
          />
        </div>
      </div>
    </div>
  );
};
export default Invoices;

{
  /* <Tabs
          tabs={[
            {
              title: "Opened Invoices",
              content: (
                <>
                  <InvoicesFilter
                    productId={productId}
                    memberId={memberId}
                    setMemberId={setMemberId}
                    setProductId={setProductId}
                    setTotal={setTotal}
                    FPage={FPage}
                    setList={setList}
                    setLoading={setLoading}
                    list={FList}
                    selectionModel={selectionModel}
                    status="open"
                  />
                  <OpenedInvoices
                    productId={productId}
                    memberId={memberId}
                    FList={FList}
                    FTotal={FTotal}
                    setPage={setPage}
                    loading={loading}
                    setSelectionModel={setSelectionModel}
                  />
                </>
              ),
            },
            {
              title: "Closed Invoices",
              content: (
                <>
                  <InvoicesFilter
                    status="close"
                    productId={productId}
                    memberId={memberId}
                    setMemberId={setMemberId}
                    setProductId={setProductId}
                  />
                  <ColsedInvoices productId={productId} memberId={memberId} />
                </>
              ),
            },
          ]}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          type="secondary"
        ></Tabs> */
}
